import { render, staticRenderFns } from "./MKBTree.vue?vue&type=template&id=9834c364&scoped=true"
import script from "./MKBTree.vue?vue&type=script&lang=js"
export * from "./MKBTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9834c364",
  null
  
)

export default component.exports